import getMonthName from './get-month-name';

export { getMonthName };

export default getMonthName;
